import { categoryOptions, parseCategoryValue } from '@/utils/creator-helpers';
import { rankToFollowerRange } from '@/utils/formatters';
import type { CategorySel, CreatorSex, CreatorStatus } from '@/types';

export const ALL = '__all__';

export const CAT_OPTS = [
  { value: ALL, label: 'Todas' },
  ...categoryOptions().map((o) => ({ value: o.value, label: o.label })),
];

export const RANK_OPTS = [
  { value: ALL, label: 'Todos' },
  ...[11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1].map((r) => ({
    value: String(r),
    label: rankToFollowerRange(r),
  })),
];

const STATUS_LABELS: Record<CreatorStatus, string> = {
  new: 'Nuevo',
  contacted: 'Contactado',
  negotiating: 'En negociación',
  closed_won: 'Cerrado ganado',
  closed_lost: 'Cerrado perdido',
  promotion: 'Promoción',
};

export const STATUS_OPTS = [
  { value: ALL, label: 'Todos' },
  ...(Object.keys(STATUS_LABELS) as CreatorStatus[]).map((s) => ({
    value: s,
    label: STATUS_LABELS[s],
  })),
];

export const SEX_OPTS = [
  { value: ALL, label: 'Todos' },
  { value: 'H', label: 'Hombre' },
  { value: 'M', label: 'Mujer' },
];

export function toVal(v: string): string {
  return v === ALL ? '' : v;
}

export function parseCat(v: string): CategorySel | undefined {
  const raw = toVal(v);
  if (!raw) return undefined;
  return parseCategoryValue(raw) ?? undefined;
}

export function parseStatus(v: string): CreatorStatus | undefined {
  return (toVal(v) || undefined) as CreatorStatus | undefined;
}

export function parseSex(v: string): CreatorSex | undefined {
  return (toVal(v) || undefined) as CreatorSex | undefined;
}
